if (!customElements.get('klaviyo-footer-trigger')) {
  customElements.define('klaviyo-footer-trigger', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        if (!event.target.closest('button')) return;

        const formId = (this.dataset.formId || '').trim();
        if (!formId) return;

        event.preventDefault();
        // Klaviyo also consumes this queue when its onsite script loads later.
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    }
  });
}
